<sn-drawer>
  <ng-template [ngIf]="logoIsCollapse" [ngIfElse]="expandedLogo">
    <sn-brand-logo
      [ngStyle]="{ cursor: 'pointer' }"
      type="icon"
      size="xsm"
      (click)="goToMap()"
    ></sn-brand-logo>
  </ng-template>
  <ng-template #expandedLogo>
    <div class="navbar-logo-container">
      <sn-brand-logo
        [ngStyle]="{ cursor: 'pointer', width: '50%' }"
        type="horizontal"
        size="sm"
        [inverse]="isDark"
        (click)="goToMap()"
      ></sn-brand-logo>
      <span class="muted-text navbar-version-text">
        {{ version }} <span *ngIf="backendVersion"> / {{ backendVersion }}</span>
      </span>
    </div>
  </ng-template>

  <sn-drawer-content>
    <ng-content></ng-content>
  </sn-drawer-content>
</sn-drawer>
